import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'

const FIRST_PAGE = 1
const DEFAULT_PAGE = FIRST_PAGE
const DEFAULT_SIZE = 30

export class PaginationSearchValueObject extends ValueObject {
  #page
  #size

  constructor({page, size}) {
    super()
    this.#page = page
    this.#size = size
  }

  static create({page, size}) {
    return new PaginationSearchValueObject({page, size})
  }

  static createWithDefaultValue({page, size}) {
    return new PaginationSearchValueObject({page: page || DEFAULT_PAGE, size: size || DEFAULT_SIZE})
  }

  static createFromFilters({config, page, size}) {
    return PaginationSearchValueObject.createWithDefaultValue({config, page, size})
  }

  static createWithPaginationMap({config, pagination}) {
    return PaginationSearchValueObject.createWithDefaultValue({
      config,
      page: pagination.page,
      size: pagination.size
    })
  }

  static createQueryParams({config, page}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new PaginationSearchValueObject({
      page: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.PAGE_NUMBER],
        value: page
      })
    })
  }

  get isFirstPage() {
    return this.#page.value === FIRST_PAGE
  }

  get hasQueryParams() {
    return Boolean(Object.keys(this.queryParams).length)
  }

  get queryParams() {
    return {
      ...(!this.isFirstPage && !this.#page.isEmpty && {...this.#page.queryParam})
    }
  }

  get page() {
    return this.#page
  }

  get size() {
    return this.#size
  }

  get value() {
    return {page: this.#page, size: this.#size}
  }

  toJSON() {
    return {page: this.#page, size: this.#size}
  }
}
